/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ProjectDto { 
    id?: number;
    code?: string;
    description?: string;
    wbsLastSync?: Date;
    wbsId?: number;
    name?: string;
    type?: string;
    client?: string;
    location?: string;
    logo?: string;
    _default?: boolean;
    usingProjectWbs?: boolean;
    closed?: boolean;
    isSynchronizationActive?: boolean;
    lastSynchronizationInfo?: string;
    synchronizationType?: string;
}